export default async function getCampaignData (clientId,campaignId) {
    const url = `https://adyogiadsapi.adyogi.com/client/${clientId}/campaigns/${campaignId}?source=amazon`  
    try {
        const respsonse = await fetch(url);
        const result = await respsonse.json();
        return result
    } catch (error) {
        return error.message
    }
}